export const RequiredProfiles = ['allstaff_outstaff_ext'] as const;
